import { Clock, Plus } from "lucide-react";

export function DailyPlanMealDisplay({
  mealData,
  handleOpenModal,
  currentDayIndex,
  mealTypes,
  isPastWeek,
}) {
  const renderMealBadges = (entry) => {
    const badges = [];

    if (entry.isLeftover) {
      badges.push(
        <span
          key="leftover"
          className="px-2 py-0.5 text-xs bg-blue-100 text-blue-700 rounded-full font-medium"
        >
          Leftover
        </span>,
      );
    }

    if (entry.ingredientMultiplier === 2) {
      badges.push(
        <span
          key="multiplier"
          className="px-2 py-0.5 text-xs bg-green-100 text-green-700 rounded-full font-medium"
        >
          2x Portions
        </span>,
      );
    }

    return badges;
  };

  const getDailyTotalMins = () =>
    mealTypes.reduce((sum, meal) => {
      return sum + (mealData[meal] || []).reduce((s, e) => s + (e.timeMins || 30), 0);
    }, 0);

  const formatTotalTime = (mins) => {
    if (mins === 0) return null;
    if (mins < 60) return `~${mins}m`;
    const h = Math.floor(mins / 60);
    const m = mins % 60;
    return m > 0 ? `~${h}h ${m}m` : `~${h}h`;
  };

  const totalTime = formatTotalTime(getDailyTotalMins());

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-1.5 text-xs text-muted-foreground h-[18px]">
        {totalTime && (
          <>
            <Clock className="w-3.5 h-3.5" />
            <span>{totalTime} total cook time today</span>
          </>
        )}
      </div>
      {mealTypes.map((meal) => {
        return (
          <div key={meal} className="space-y-2">
            <h3 className="text-sm font-medium text-gray-700">{meal}</h3>
            <div
              onClick={isPastWeek ? undefined : () => handleOpenModal(currentDayIndex, meal)}
              className={`bg-white border border-gray-200 rounded-lg p-4 min-h-[80px] transition-colors ${
                isPastWeek ? "opacity-60" : "hover:border-gray-300 cursor-pointer"
              }`}
            >
              {mealData[meal]?.length > 0 ? (
                <div className="max-h-24 overflow-y-auto space-y-2">
                  {mealData[meal]?.map((entry) => (
                    <div key={entry.entryId} className="flex items-start justify-between gap-2">
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-gray-900 truncate">
                          {entry.mealName}
                        </p>
                        {renderMealBadges(entry).length > 0 && (
                          <div className="flex gap-1 mt-0.5">
                            {renderMealBadges(entry)}
                          </div>
                        )}
                      </div>
                      <div className="flex items-center gap-1 shrink-0 text-xs text-muted-foreground mt-0.5">
                        <Clock className="w-3 h-3" />
                        <span>{entry.timeMins || 30}m</span>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                !isPastWeek && (
                  <div className="flex items-center justify-center h-full text-gray-400">
                    <Plus className="w-5 h-5" />
                  </div>
                )
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
